// mapbox-gl's package.json declares "type": "module", which makes Webpack
// treat its UMD-style bundle as native ESM and wrap the default export in a
// frozen namespace object. Assigning `mapboxgl.workerUrl = ...` on that
// wrapper (which is what react-map-gl's own `workerUrl` prop does internally)
// then fails with:
//   "Cannot set property workerUrl of [object Module] which has only a getter"
// `require()` forces CommonJS interop instead, returning mapbox-gl's real
// mutable export object, so the assignment below actually sticks.
// This also uses the `-csp` build, which doesn't try to spin up its worker
// from a Blob URL (blocked under some CSPs) — see the worker file copied to
// public/mapbox-gl-csp-worker.js.
// https://docs.mapbox.com/mapbox-gl-js/api/properties/#workerurl
// eslint-disable-next-line @typescript-eslint/no-var-requires
const mapboxgl = require('mapbox-gl/dist/mapbox-gl-csp');

mapboxgl.workerUrl = '/mapbox-gl-csp-worker.js';

export default mapboxgl;
